import { pxToRem, stringLiteralsArray } from '../../../../lib';
import { pickValuesFromColorScheme } from '../../../colorUtils';
export var dividerColorAreas = stringLiteralsArray('foreground');
export default (function (siteVars) {
  return {
    colorScheme: pickValuesFromColorScheme(siteVars.colorScheme, dividerColorAreas),
    dividerColor: siteVars.colors.grey[150],
    textColor: siteVars.colors.grey[450],
    textFontSize: siteVars.fontSizeSmall,
    textLineHeight: siteVars.lineHeightSmall,
    importantFontWeight: siteVars.fontWeightBold,
    dividerPadding: pxToRem(4)
  };
});